import styles from './LPFooter.module.scss'

const LPFooter: React.FunctionComponent = () => {
  return (
    <>
      <section className={styles.contact} id="contact">
        <p>Contact</p>
        <h4>
          ご相談はお気軽に
          <br className={styles.spBr} />
          お問い合わせください
        </h4>
        <a href="https://www.i3design.jp/contact" target="_blank" rel="noopener" className={styles.contactBadge}>
          <span>
            <img src="/img/LP/flamingo/red-allow.png" alt="" />
          </span>
        </a>
      </section>
      {/*　<footer className={styles.footer}>
        <div className={styles.contents}>
          <img className={styles.flamingoLogo} src="/img/LP/flamingo/flamingo_new_footerlogo-1.png" alt="フラミンゴロゴ" />
          <div className={styles.list}>
            <ul>
              <li className={styles.title}>プロダクト</li>
              <li className={styles.link}>
                <a href="/services/flamingo/functions/">機能</a>
              </li>
            </ul>
            <ul>
              <li className={styles.title}>サービス</li>
              <li className={styles.link}>
                <a href="https://www.i3design.jp/services/uiuxdesign" target="_blank" rel="noopener">UI/UXデザイン
                  <img className={styles.inNew} src="/img/LP/flamingo/open-in-new.png" alt="別タブ表示" />
                </a>
              </li>
              <li className={styles.link}>
                <a href="https://www.i3design.jp/services/frontend" target="_blank" rel="noopener">フロントエンド開発
                  <img className={styles.inNew} src="/img/LP/flamingo/open-in-new.png" alt="別タブ表示" />
                </a>
              </li>
              <li className={styles.link}>
                <a href="https://www.i3design.jp/services/growthhack" target="_blank" rel="noopener">サイト改善ソリューション
                  <img className={styles.inNew} src="/img/LP/flamingo/open-in-new.png" alt="別タブ表示" />
                </a>
              </li>
            </ul>
            <ul>
              <li className={styles.title}>運営会社</li>
              <li className={styles.link}>
                <a href="https://www.i3design.jp" target="_blank" rel="noopener">
                  <img className={styles.i3dLogo} src="/img/LP/flamingo/ft_i3design_logo.png" alt="i3ロゴ" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p className={styles.copyright}>
          Copyright © i3DESIGN Co., Ltd. All rights reserved.
        </p>
      </footer>*/}
    </>
  )
}

export default LPFooter
